export const RECEIVE_DIFFERENCES = "RECEIVE_DIFFERENCES";

export const receiveDifferences = differences => ({
    type: RECEIVE_DIFFERENCES,
    differences
});